<template lang='pug'>
.messages.pa-5(id="chatFrame")
  .message-wrapper.d-flex.mb-5(
    v-for="message in messages",
    :class="{ 'message__right': message.is_my \
                              || message.owner_id === user.id  }"
  )
    v-sheet.message
      div(v-html="message.text")
      .message__images.mt-5(
        v-if="(message.images || []).length"
      )
        Element.mr-2.mb-2.message__images-image.v-sheet--outlined.pointer(
          v-for="image in (message.images || [])"
          :key="image.id"
          :url="image.url"
          :name="image.original_name || image.name"
          max-height="100px"
          cover
          color="grey"
        )
      v-img.mr-2.mb-2.message__images-image.pointer(
        v-for="document in (message.documents || [])"
        :key="document.url"
      )
        a(:href="document.url" target="_blank")
          Element(
            :name="document.original_name || document.name"
          )
      .message__date
        | {{ (message.send_at  || message.created_at) | readableDateTime }}
  div(v-if="messages.length" v-intersect="onIntersect")
</template>

<script>
import Element from '@/components/icons/Element.vue';
import mixinDateTime from '@/mixins/mixinDateTime';
import { mapGetters } from 'vuex';

export default {
  components:{ Element },
  mixins:[mixinDateTime],
  props:{
    messages: { type:Array, required: true },
  },
  computed:{
    ...mapGetters({
      'user':'auth/getUser',
    }),
  },
  mounted() {
    const objDiv = document.getElementById('chatFrame');
    objDiv.scrollTop = objDiv.scrollHeight;
  },
  methods: {
    onIntersect(entries) {
      if (entries[0].isIntersecting) this.$emit('intersect');
    },
  },
}; </script>

<style lang='scss'>
.messages {
  background: #ecf0f1;
  max-height: 400px;
  overflow-y: auto;

  .message {
    border-radius: 5px;
    padding: 15px;
    background: #f9e8fa;
    width: 80%;
    max-width: 750px;
    position: relative;
    border: thin solid #f0c5f3;

    p {
      margin-bottom: 0;
    }

    &__right{
      display: flex;
      flex-direction: row-reverse;
      .message {
        background: #ebedfb;
        border-color: #bfc5c9;
      }
    }

    &__date{
      font-size: 0.8rem;
      opacity: 0.5;
    }

    &__avatar {
      position:sticky;top:-10px
    }

    &__images {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
      grid-template-rows: repeat(auto-fit, minmax(100px, 1fr));
      grid-gap: 10px;
    }
  }
}
</style>
